module.exports = __webpack_public_path__ + "static/media/car4.500f5b6e.jpg";